export default {"src":"/_next/static/media/headphones.da4978fe.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};